import FetchFactory from '../factory';
const CONTROLLER = '/api-electra/AggregatedProduct';
class AggregatedProductModule extends FetchFactory<{
  ProductAttributeCombinationId?: number;
  [key: string]: unknown;
}> {
  async GetByProductId(id: string) {
    const url = `${CONTROLLER}/GetByProductId/${id}`;
    return await this.get(url);
  }
}

export default AggregatedProductModule;
